// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","455":"b06868b9","977":"2caed02d"}[chunkId] + ".chunk.js";
};